export default __webpack_public_path__ + "static/media/info.db93faef.svg";